<h1 id="step-heading" class="step-heading">
  <%= I18n.patient.mychart.sign_in.title %>
</h1>

<div class="step-form">
  <div class="appointment-booking-wizard-callout borderless">
    <% if (patient_id) { %>
      <div class="message message-success">
        <p><%= I18n.patient.mychart.sign_in.success %></p>
      </div>
    <% } else if (mychart_login_error) { %>
      <div class="message message-error">
        <p>
          <%= I18n.patient.mychart.sign_in.error_html %>
        </p>
      </div>
    <% } else { %>
      <div class="message message-warning">
        <p><%= I18n.patient.mychart.sign_in.info %></p>
        <p><%= I18n.patient.mychart.sign_in.continue_as_guest %></p>
      </div>
    <% } %>
  </div>

  <div class="age-range-callout-container"></div>

  <div class="mychart-email-field"></div>
  <div class="mychart-patient-proxy-field"></div>
</div>
